import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { buildRoutes } from "./buildRoutes";
import { installVersionSkewGuard } from "./versionSkewGuard";

const router = createBrowserRouter(buildRoutes());

installVersionSkewGuard(router);

const Routes = () => <RouterProvider router={router} />;
export default Routes;
